module.exports = {"ziModal":20000,"ziNavFull":9000,"ziPanelbookMapTooltip":8500,"ziHeader":8000,"ziNavMobile":7000,"ziCookiesConsent":6000,"ziDrift":5000};